export default "__VITE_PUBLIC_ASSET__50f1dbea__"